package com.kinoshazam.screens.details.host

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.navigation.NavBackStackEntry
import androidx.navigation.toRoute
import com.kinoshazam.model.Route
import com.kinoshazam.screens.details.compact.CompactVideoDetailsContent
import com.kinoshazam.screens.details.expanded.ExpandedVideoDetailsWindow
import com.kinoshazam.screens.details.medium.MediumVideoDetailsContent
import features.videoDetails.VideoDetailsViewModel
import org.koin.compose.viewmodel.koinViewModel
import utils.FormFactor

@Composable
fun VideoDetailsContentHost(
    formFactor: FormFactor,
    backStackEntry: NavBackStackEntry,
) {
    val route = backStackEntry.toRoute<Route.Dialog.Details>()
    val viewModel = koinViewModel<VideoDetailsViewModel>(
        viewModelStoreOwner = backStackEntry,
        key = "details_${route.id}_${route.isSerial}",
    )
    val state by viewModel.state.collectAsStateWithLifecycle()

    when (formFactor) {

        is FormFactor.Compact -> CompactVideoDetailsContent(
            state = state,
            onAction = viewModel::onAction,
        )

        is FormFactor.Medium -> CompactVideoDetailsContent(
            state = state,
            onAction = viewModel::onAction,
        )

        is FormFactor.Expanded -> MediumVideoDetailsContent(
            state = state,
            onAction = viewModel::onAction,
        )

        is FormFactor.ExtraLarge -> ExpandedVideoDetailsWindow(
            state = state,
            onAction = viewModel::onAction,
        )
    }
}
